import { Trans } from '@lingui/macro'
import { ColumnsType } from 'antd/lib/table'
import Text from 'components/atoms/text'
import cdeStatusDict from 'data/cdeStatus'
import trans from 'helpers/i18n.helpers'
import CdeStatusPermissions from './CdeStatusPermissions'

export interface DisciplinePermissionRowProps {
  disciplineId: number
  disciplineName: string
}

const useMembersPermissionsColumns = (): ColumnsType<DisciplinePermissionRowProps> => [
  {
    title: <Trans id="project_config.members_permission.table.column_discipline_label">Discipline in project</Trans>,
    dataIndex: 'discipline',
    key: 'discipline',
    width: 180,
    render: (value, { disciplineName }) => <Text textStyle="regularText-small">{disciplineName}</Text>,
  },
  {
    title: trans(cdeStatusDict.IN_PROGRESS.abbr),
    dataIndex: 'IN_PROGRESS',
    key: 'IN_PROGRESS',
    width: 180,
    render: (value, { disciplineId }) => <CdeStatusPermissions disciplineId={disciplineId} cdeStatus="IN_PROGRESS" />,
  },
  {
    title: trans(cdeStatusDict.SHARED.abbr),
    dataIndex: 'SHARED',
    key: 'SHARED',
    width: 180,
    render: (value, { disciplineId }) => <CdeStatusPermissions disciplineId={disciplineId} cdeStatus="SHARED" />,
  },
  {
    title: trans(cdeStatusDict.PUBLISHED.abbr),
    dataIndex: 'PUBLISHED',
    key: 'PUBLISHED',
    width: 180,
    render: (value, { disciplineId }) => <CdeStatusPermissions disciplineId={disciplineId} cdeStatus="PUBLISHED" />,
  },
  {
    title: trans(cdeStatusDict.ARCHIVED.abbr),
    dataIndex: 'ARCHIVED',
    key: 'ARCHIVED',
    width: 180,
    render: (value, { disciplineId }) => <CdeStatusPermissions disciplineId={disciplineId} cdeStatus="ARCHIVED" />,
  },
]

export default useMembersPermissionsColumns
